<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="开始日期" prop="startDate">
                <el-date-picker
                  v-model="queryForm.startDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="endDate">
                <el-date-picker
                  v-model="queryForm.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getTableData">查询</el-button>
                <!--<el-button @click="resetForm('queryForm')">重置</el-button>-->
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <el-button type="primary" size="mini" @click="printPDF">打印</el-button>
        </el-row>

        <!--table-->
        <div class="report" v-loading="loading">
            <div class="header">
                <p>SHU商户结算汇总表</p>
                <p>时间{{this.startDate}}至{{this.endDate}}</p>
            </div>
            <div class="body" v-if="tableData.length>0">
                <el-row>
                    <el-col :span="4"><div class="td">商户名称</div></el-col>
                    <el-col :span="2"><div class="td">支付方式</div></el-col>
                    <el-col :span="6"><div class="td b-fcf850">交易</div></el-col>
                    <el-col :span="6"><div class="td b-94d14f">冲正</div></el-col>
                    <el-col :span="6"><div class="td b-f2af85 no-br">合计</div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="4"><div class="td">&nbsp;</div></el-col>
                    <el-col :span="2"><div class="td">&nbsp;</div></el-col>
                    <el-col :span="6">
                        <el-row>
                            <el-col :span="6"><div class="td b-fcf850">交易人次</div></el-col>
                            <el-col :span="6"><div class="td b-fcf850">营业额</div></el-col>
                            <el-col :span="6"><div class="td b-fcf850">搭伙费</div></el-col>
                            <el-col :span="6"><div class="td b-fcf850">结算金额</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="6">
                        <el-row>
                            <el-col :span="6"><div class="td b-94d14f">交易人次</div></el-col>
                            <el-col :span="6"><div class="td b-94d14f">营业额</div></el-col>
                            <el-col :span="6"><div class="td b-94d14f">搭伙费</div></el-col>
                            <el-col :span="6"><div class="td b-94d14f">结算金额</div></el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="6">
                        <el-row>
                            <el-col :span="6"><div class="td b-f2af85">交易人次</div></el-col>
                            <el-col :span="6"><div class="td b-f2af85">营业额</div></el-col>
                            <el-col :span="6"><div class="td b-f2af85">搭伙费</div></el-col>
                            <el-col :span="6"><div class="td b-f2af85 no-br">结算金额</div></el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <div v-for="(item,index) in tableData" :key="index">
                    <el-row v-for="(item1,index1) in item.child" :key="index1">
                        <el-col :span="4" style="position: relative">
                            <div v-if="item.child.length > 1">
                                <div v-if="index1==0" style="position: absolute;top: 0;left: 0;width: 100%;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" :style="{'height':((item.child.length)*24)+'px','line-height':((item.child.length)*24)+'px'}">{{item1.commercialName}}</div>
                                <div class="td" :class="index1>0?'no-bt':''">&nbsp;</div>
                            </div>
                            <div v-else>
                                <div class="td">{{item1.commercialName}}</div>
                            </div>
                        </el-col>
                        <el-col :span="2"><div class="td">{{item1.title}}</div></el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="6"><div class="td">{{item1.tradeCount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.tradeAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.tradeExtraAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.tradeSettleAmount}}</div></el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="6"><div class="td">{{item1.refundCount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.refundAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.refundExtraAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.refundSettleAmount}}</div></el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="6"><div class="td">{{item1.totalCount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.totalAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item1.totalExtraAmount}}</div></el-col>
                                <el-col :span="6"><div class="td no-br">{{item1.totalSettleAmount}}</div></el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6"><div class="td">{{item.commercialName}}</div></el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="6"><div class="td">{{item.tradeCount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.tradeAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.tradeExtraAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.tradeSettleAmount}}</div></el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="6"><div class="td">{{item.refundCount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.refundAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.refundExtraAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.refundSettleAmount}}</div></el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="6"><div class="td">{{item.totalCount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.totalAmount}}</div></el-col>
                                <el-col :span="6"><div class="td">{{item.totalExtraAmount}}</div></el-col>
                                <el-col :span="6"><div class="td no-br">{{item.totalSettleAmount}}</div></el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="footer" v-if="tableData.length>0">
                <el-row type="flex" justify="space-around">
                    <el-col :span="6">制表人</el-col>
                    <el-col :span="6">审核人</el-col>
                    <el-col :span="6">制表时间</el-col>
                </el-row>
            </div>
            <div class="no-data" v-else>暂无数据～</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    startDate: '',
                    endDate: '',
                    // userType: this.$store.getters.type == 1?2:3,
                    // schoolId: 337,
                    // merchantId: 107,
                    for_report: true
                },

                tableData: {},
                startDate: '',
                endDate: '',
                loading: false
            }
        },
        created(){
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.startDate = day;
            this.queryForm.endDate = new Date();
            if(this.$store.getters.type == 1){
                this.queryForm.userType = 2;
                this.queryForm.schoolId = JSON.parse(localStorage.getItem('accountInfo')).school_id;
            }else{
                this.queryForm.userType = 3;
                // this.queryForm.schoolId = JSON.parse(localStorage.getItem('accountInfo')).school_id;
                this.queryForm.merchantId = JSON.parse(localStorage.getItem('accountInfo')).commercial_id;
            }
            this.getTableData();
        },
        methods: {
            getTableData() {
                this.loading = true;
                this.tableData = [];
                let params = {...this.queryForm};
                params.startDate = this.startDate = moment(params.startDate).format('YYYY-MM-DD');
                params.endDate = this.endDate = moment(params.endDate).format('YYYY-MM-DD');
                this.$apiJava.post(this.$apiUrl.reportPartnerSettle,params,(res)=>{
                    this.tableData = res.data;
                    this.loading = false;
                },(res)=>{
                    this.$message.warning(res.message);
                    this.tableData = {};
                    this.loading = false;
                },'oc')
            },
            printPDF() {
                let hostStr = window.location.host;
                let host = hostStr.replace('e','oc');
                let url;
                if(this.queryForm.schoolId){
                    url = location.protocol +'//'+ host + '/' + this.$apiUrl.reportPartnerExportPDF + '?userType=' + this.queryForm.userType + '&schoolId=' + this.queryForm.schoolId + '&startDate=' + moment(this.queryForm.startDate).format('YYYY-MM-DD') + '&endDate=' + moment(this.queryForm.endDate).format('YYYY-MM-DD') + '&export=3';
                }else{
                    url = location.protocol +'//'+ host + '/' + this.$apiUrl.reportPartnerExportPDF + '?userType=' + this.queryForm.userType + '&merchantId=' + this.queryForm.merchantId + '&startDate=' + moment(this.queryForm.startDate).format('YYYY-MM-DD') + '&endDate=' + moment(this.queryForm.endDate).format('YYYY-MM-DD') + '&export=3';
                }
                window.open(url);
            }
        }
    }
</script>
<style lang="scss"  scoped>
    .report{
        width: 100%;
        /*min-height: 500px;*/
        border: 1px solid #ddd;
        text-align: center;
        font-size: 13px;
    }
    .report .header{
        font-size: 16px;
        padding: 20px 0;
    }
    .report .body{
        border-bottom: 1px solid #ddd;
    }
    .report .body .td{
        border: 1px solid #ddd;
        border-left: none;
        border-bottom: none;
        padding: 2px 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .report .body .td.no-br{
        border-right: none;
    }
    .report .body .td.no-bt{
        border-top: none;
    }
    .report .body .td.bg{
        background-color: #f3b084;
    }
    .report .footer{
        padding: 20px 0;
        text-align: left;
    }
    .b-fcf850{
        background-color: #fcf850;
    }
    .b-94d14f{
        background-color: #94d14f;
    }
    .b-f2af85{
        background-color: #f2af85;
    }
    .no-data{
        padding: 20px 0;
    }
</style>


// WEBPACK FOOTER //
// settle.vue?299e1e10